import { RRule } from "rrule";
import { EventCreationContext } from "../../event_creation";
import RepeatForm from "./repeat_form/repeat_form";
import { SeshAccordianComponent } from "./sesh_accordian_component";
import React, { useContext, useState } from "react";
import { DateTime } from "luxon";

export function RepeatFormComponent(props: {
	end_time: DateTime | undefined;
	disabled?: boolean;
}) {
	const event_context = useContext(EventCreationContext);
	const { state: event_state, setState, props: event_props } = event_context;

	const [ephemeral_rrule, setEphemeralRRule] = useState(
		event_state.rrule ??
			new RRule({
				freq: RRule.WEEKLY,
				interval: 1,
			})
	);

	const is_enabled = !!event_state.rrule;

	const repeat_form = (
		<RepeatForm
			event_timezone={event_state.event_timezone}
			guild_timezone={event_state.guild_timezone}
			user_timezone={event_state.user_timezone}
			use_24h_clock={event_state.use_24h_clock}
			previous_event_timezone={event_props.edit_data?.event_timezone}
			initial_value={ephemeral_rrule}
			start_time={event_state.start_time}
			end_time={props.end_time}
			allow_maintaining_rsvp={event_state.allow_maintain_repeat_rsvp}
			rruleUpdateFunc={(val) => {
				if (!is_enabled || props.disabled) {
					return;
				}
				setState({ rrule: val });
				setEphemeralRRule(val);
			}}
			eventTimezoneUpdateFunc={(val) => {
				if (!is_enabled || props.disabled) {
					return;
				}
				setState({ event_timezone: val });
			}}
			maintainRSVPUpdateFunc={(val) => {
				if (!is_enabled || props.disabled) {
					return;
				}
				setState({
					allow_maintain_repeat_rsvp: val,
				});
			}}
			should_hide_time_listing={!is_enabled}
		/>
	);

	return (
		<SeshAccordianComponent
			is_opened={is_enabled}
			does_require_premium={true}
			does_server_have_premium={event_props.is_premium}
			label={"Repeat"}
			info={"Repeat options for this event"}
			onChange={(val) => {
				if (props.disabled) {
					return;
				}
				setState({
					rrule: val ? ephemeral_rrule : null,
				});
			}}
			disabled={props.disabled}
			closed_element={
				<div className="cursor-not-allowed opacity-25">
					<div className="disable-pointer-events">{repeat_form}</div>
				</div>
			}
		>
			{repeat_form}
		</SeshAccordianComponent>
	);
}

{
	/* <SeshAccordian
    key="rrule"
    initial_value={event_state.rrule}
    opened_initially={Boolean(this.state.rrule)}
    field_key="rrule"
    is_server_premium={
        this.props.is_premium || this.state.can_make_recurring
    }
    onCheckboxUnclicked={() => this.updateState("rrule", null)}
    label="Repeat"
    info="Repeat options for this event"
    disabled={force_disable}
    render_child={(field_key, initial_value) => {
        return (
            <RepeatForm
                event_timezone={this.state.event_timezone}
                guild_timezone={this.state.guild_timezone}
                user_timezone={this.state.user_timezone}
                use_24h_clock={this.state.use_24h_clock}
                previous_event_timezone={
                    this.props.edit_data?.event_timezone
                }
                initial_value={initial_value}
                start_time={this.state.start_time}
                end_time={this.getCalculatedEndTimeIfSet()}
                allow_maintaining_rsvp={
                    this.state.allow_maintain_repeat_rsvp
                }
                rruleUpdateFunc={(val) =>
                    this.updateState(field_key, val)
                }
                eventTimezoneUpdateFunc={(val) =>
                    this.setState({
                        event_timezone: val,
                    })
                }
                maintainRSVPUpdateFunc={(val) =>
                    this.setState({
                        allow_maintain_repeat_rsvp: val,
                    })
                }
            />
        );
    }}
></SeshAccordian> */
}
